import React, {useCallback, forwardRef} from 'react';
import {multipass} from '~/lib/multipass/multipass';

export const MultipassCheckoutButton = forwardRef((props, ref) => {
  const {
    children,
    onClick,
    checkoutUrl,
    redirect = true,
    as = 'button',
  } = props;

  const Element = as;

  const checkoutHandler = useCallback(
    async (event) => {
      event.preventDefault();
      if (!checkoutUrl) return;

      if (typeof onClick === 'function') {
        onClick();
      }

      // If the user is logged in, we persist it in the checkout,
      // otherwise, we log them out of the checkout too.
      return await multipass({
        return_to: checkoutUrl,
        redirect,
      });
    },
    [redirect, checkoutUrl, onClick],
  );

  return (
    <Element ref={ref} onClick={checkoutHandler}>
      {children}
    </Element>
  );
});

export default MultipassCheckoutButton;
